import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to extract dossier_id from URL query parameters
 * @returns The dossier_id from URL search params, or null if not found
 */
const useDossierIdParam = (): string | null => {
  const location = useLocation();

  const dossierId = useMemo(() => {
    if (typeof window === 'undefined') return null;
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('dossier_id') ?? null;
  }, [location.search]);

  return dossierId;
};

export default useDossierIdParam;
